export type SessionCategory = "web" | "mobile";

const MOBILE_UA_REGEX = /android|iphone|ipad|mobile/i;

export const isMobileUserAgent = (ua: string | null | undefined): boolean => {
    if (!ua) return false;
    return MOBILE_UA_REGEX.test(ua);
};

/**
 * Best-effort UA-based category detection. Native mobile apps are not detectable
 * from UA today (MIG-7819 covers fingerprinting); only mobile-web is bucketed.
 */
export const categoryFromUserAgent = (ua: string | null | undefined): SessionCategory =>
    isMobileUserAgent(ua) ? "mobile" : "web";
